/**
 * トップの紹介バンドで使う図形。
 *
 * アイコンのライブラリは入れていない。4つのために依存を増やす理由がなく、
 * ヒーローに散らしている牌の絵柄と同じで、必要な形はその場で描く方針。
 *
 * 幅がそれぞれ違うのは viewBox の縦横比が違うためで、見た目の大きさを
 * 揃えた結果。丸の中に置く前提で決めた値なので、他所で使うときは要調整。
 */

/**
 * 雀点のマーク。牌に一索を入れている。
 *
 * 一索は麻雀では昔から鳥の絵で描かれる牌で、「雀」という名前と麻雀の
 * 両方に一度に効く。文字を使っていないので、フォントの読み込み待ちで
 * 形が変わることはない。
 *
 * 色を currentColor にせず焼き込んでいるのは、これがブランドのマークで、
 * 置く場所（ヒーロー・ファビコン・OGP）によらず同じ見た目であるべきだから。
 * 牌の面が地より明るいのは実物と同じ関係で、グラデーションの上でも沈まない。
 */
export function JongtenMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 60" className={className} aria-hidden>
      <rect x="2" y="2" width="44" height="56" rx="7" fill="#F8F5EC" stroke="#123528" strokeWidth="3" />
      <g fill="#123528">
        <ellipse cx="26.5" cy="32" rx="9" ry="10" />
        <circle cx="19" cy="21.5" r="6.2" />
        <path d="M13.4 19.6 L7.5 22.2 L13.4 24.8 Z" />
        <path d="M33 37.5 L42 45 L31.5 42.5 Z" />
      </g>
      {/* 目と翼は牌の面の色で抜く。線を足すと小さいときに潰れる */}
      <circle cx="17.4" cy="19.8" r="1.7" fill="#F8F5EC" />
      <path
        d="M23 28.5q6 3.2 8.2 9.2"
        fill="none"
        stroke="#F8F5EC"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** 3人。中央を大きく前に、左右を小さく後ろに。重ねると線が交差して潰れるので離してある */
export function GroupIcon() {
  return (
    <svg
      viewBox="0 0 34 24"
      className="w-[29px]"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="5.5" cy="7.5" r="2.8" />
      <path d="M.8 18c0-2.7 2.1-4.8 4.7-4.8" />
      <circle cx="28.5" cy="7.5" r="2.8" />
      <path d="M33.2 18c0-2.7-2.1-4.8-4.7-4.8" />
      <circle cx="17" cy="6.8" r="4.2" />
      <path d="M9.4 21c0-4.2 3.4-7.6 7.6-7.6s7.6 3.4 7.6 7.6" />
    </svg>
  );
}

/** 用紙とペン。3本目の罫線だけ短いのは、ペン先とぶつかるため */
export function NoteIcon() {
  return (
    <svg
      viewBox="0 0 27 28"
      className="w-[26px]"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="1.5" y="1.5" width="18" height="25" rx="2.5" />
      <path d="M6 8h9M6 12.5h9M6 17h5" />
      <path d="M25.4 8.6a2.2 2.2 0 0 0-3.1-3.1l-8.2 8.2-1 4.1 4.1-1 8.2-8.2z" />
    </svg>
  );
}

/** 右上がりの棒3本。他2つが線画なので塗らずに線で揃えている */
export function BarsIcon() {
  return (
    <svg
      viewBox="0 0 26 24"
      className="w-[26px]"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="1.5" y="13.5" width="6" height="9" rx="1.5" />
      <rect x="10" y="7.5" width="6" height="15" rx="1.5" />
      <rect x="18.5" y="1.5" width="6" height="21" rx="1.5" />
    </svg>
  );
}
